import { render } from "./MenuCdm.vue?vue&type=template&id=2099f323&scoped=true"
import script from "./MenuCdm.vue?vue&type=script&lang=js"
export * from "./MenuCdm.vue?vue&type=script&lang=js"

import "./MenuCdm.vue?vue&type=style&index=0&id=2099f323&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2099f323"]])

export default __exports__